"use strict";

import angular from "angular";
angular.module("nucont.accounting.overview").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.overview.portfolio.groups.resume", {
            url: "/resumo",
            params: {},
            views: {
                "submodules@nucont.accounting.overview.portfolio.groups": {
                    component: "accountingGroupsResumeViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.portfolio.groups.performance", {
            url: "/performance",
            params: {},
            views: {
                "submodules@nucont.accounting.overview.portfolio.groups": {
                    component: "accountingGroupsPerformanceViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.portfolio.groups.create", {
            url: "/cadastrar",
            params: {},
            views: {
                "submodules@nucont.accounting.overview.portfolio.groups": {
                    component: "accountingGroupsCreateViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.portfolio.groups.edit", {
            url: "/editar",
            params: {
                id: { value: null, dynamic: true }
            },
            views: {
                "submodules@nucont.accounting.overview.portfolio.groups": {
                    component: "accountingGroupsCreateViewComponent"
                }
            }
        });
}
